import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EventItem from './EventItem';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';

export default class EventCluster extends PureComponent {

    static propTypes = {
        events: PropTypes.array.isRequired,
        // required by EventItem:
        onSelectEvent: PropTypes.func.isRequired,
        ravenUuid: PropTypes.string.isRequired,
        card: PropTypes.object.isRequired,
        unitOfMeasure: PropTypes.string,
        selectedEvent: PropTypes.object,
        referenceTime: PropTypes.any,
        mediaRequestType: PropTypes.string,
        renderForDashboard: PropTypes.bool,
        allSupportedEvents: PropTypes.array // legacy/dashboard
    }

    constructor(props) {

        super(props);

        this.state = {
            collapsed: true
        };

    };

    onSelectEvent = (event) => {
        if (this.state.collapsed) {
            this.setState({collapsed: false});
        }
        this.props.onSelectEvent(event);
    }

    updateClusterElements() {

        let clusterElementsContainsSelectedEvent = false;
        const currentLocale = getCurrentLocale(); // getting current local here and passing it down as a means to avoid some redundant requests to getCurrentLocale()

        let i = 0;

        let clusterSize = this.props.events[i].clusterSize; // first event in cluster has clusterSize
        let eventIsSelected = this.props.selectedEvent === this.props.events[i];
        if (eventIsSelected) {
            clusterElementsContainsSelectedEvent = true;
        }
        let clusterElements = [<EventItem
            ravenUuid={this.props.ravenUuid}
            event={this.props.events[i]}
            card={this.props.card}
            unitOfMeasure={this.props.unitOfMeasure}
            key={i}
            index={i}
            selected={eventIsSelected}
            selectEvent={this.onSelectEvent}
            referenceTime={this.props.referenceTime}
            currentLocale={currentLocale}
            mediaRequestType={this.props.mediaRequestType}
            renderForDashboard={this.props.renderForDashboard}
            allSupportedEvents={this.props.allSupportedEvents}
        />];

        i += 1;

        while (i < clusterSize) {

            eventIsSelected = this.props.selectedEvent === this.props.events[i];
            if (eventIsSelected) {
                clusterElementsContainsSelectedEvent = true;
            }

            clusterElements.push(<EventItem
                ravenUuid={this.props.ravenUuid}
                event={this.props.events[i]}
                card={this.props.card}
                unitOfMeasure={this.props.unitOfMeasure}
                key={i}
                index={i}
                selected={eventIsSelected}
                selectEvent={this.onSelectEvent}
                referenceTime={this.props.referenceTime}
                currentLocale={currentLocale}
                mediaRequestType={this.props.mediaRequestType}
                renderForDashboard={this.props.renderForDashboard}
                allSupportedEvents={this.props.allSupportedEvents}
            />);

            i += 1;
        }

        return {
            clusterElements,
            clusterElementsContainsSelectedEvent
        };

    }

    render () {

        let { clusterElements, clusterElementsContainsSelectedEvent } = this.updateClusterElements();
        let clusterClassName = "event-table-cluster";
        let clusterDisclosureTabClassName = "event-table-cluster-disclosure-tab";

        if (this.state.collapsed) {
            clusterClassName += " collapsed";
        }
        let clusterFirstEvent = this.props.events[0];
        let clusterLastEvent = this.props.events[this.props.events.length - 1]; // a cluster must always have >1 event
        // intuitive highlighting for the disclosure tab
        if (clusterElementsContainsSelectedEvent) {
            if (this.state.collapsed) {
                clusterDisclosureTabClassName += " selected";
            } else if (this.props.selectedEvent === clusterLastEvent) {
                clusterDisclosureTabClassName += " selected";
            }
        }
        let clusterSize = clusterFirstEvent.clusterSize ? clusterFirstEvent.clusterSize : this.props.events.length;
        let timelineClassName = "timeline";
        if (clusterFirstEvent.parked) {
            timelineClassName += " parked";
        }
        if (clusterFirstEvent.speeding) {
            timelineClassName += " speeding";
        }
        if (clusterFirstEvent.idling) {
            timelineClassName += " idling";
        }
        return (
            <div className="cluster-component">
                <div className={timelineClassName}>
                    <div className="timeline-top"></div>
                    <div className="timeline-bottom"></div>
                </div>
                <div className="event-icon">
                    {clusterSize}
                </div>

                <ul className={clusterClassName}>
                    {clusterElements}
                </ul>
                <div className={clusterDisclosureTabClassName}>
                    <button onClick={() => {
                        /*if (!this.state.collapsed && clusterElementsContainsSelectedEvent) {
                            if (this.props.selectedEvent !== clusterFirstEvent) {
                                // collapse "up" to selecting the topmost cluster event
                                this.props.onSelectEvent(clusterFirstEvent);
                            }
                        }*/
                        this.setState({collapsed: !this.state.collapsed});
                        }}
                    >
                        {this.state.collapsed? <i className="material-icons">keyboard_arrow_down</i> : <i className="material-icons">keyboard_arrow_up</i>}
                        {this.state.collapsed? strings.action_show_more : strings.action_show_less}
                    </button>
                </div>
            </div>
        
        );
    }
}

